import React from 'react';
import { AdaptiveModal } from '@/components/ui/AdaptiveModal';
import { TermsContent } from './TermsContent';
import { PrivacyContent } from './PrivacyContent';
import { FAQContent } from './FAQContent';

interface LegalDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentType: 'terms' | 'privacy' | 'faq' | null;
}

export const LegalDocumentModal: React.FC<LegalDocumentModalProps> = ({
  isOpen,
  onClose,
  documentType
}) => {
  const getTitle = () => {
    switch (documentType) {
      case 'terms':
        return 'Terms of Service';
      case 'privacy':
        return 'Privacy Policy';
      case 'faq':
        return 'Frequently Asked Questions';
      default:
        return '';
    }
  };

  const getContent = () => {
    switch (documentType) {
      case 'terms':
        return <TermsContent />;
      case 'privacy':
        return <PrivacyContent />;
      case 'faq':
        return <FAQContent onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      position="center"
      size="md"
      variant="form"
      scrollable={true}
      blurBackground={true}
      addBottomNavPadding={true}
    >
      {getContent()}
    </AdaptiveModal>
  );
};